export default __webpack_public_path__ + "static/media/upload.aecf441c.png";